import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

import AgentProfile from 'models/agent_profile';
import connect from 'components/lib/connect';

const CurrentAgentContext = React.createContext({});
export default CurrentAgentContext;

export function CurrentAgentProviderBase({ currentAgent, children }) {
  const value = useMemo(() => ({ currentAgent }), [currentAgent]);

  return <CurrentAgentContext.Provider value={value}>{children}</CurrentAgentContext.Provider>;
}

CurrentAgentContext.propTypes = {
  children: PropTypes.any,
  currentAgent: PropTypes.instanceOf(AgentProfile),
};

export const CurrentAgentProvider = connect(mapStateToProps)(CurrentAgentProviderBase);

function mapStateToProps({ getProvider }) {
  return {
    currentAgent: getProvider('currentAgent').get(),
  };
}

export function useCurrentAgent() {
  return useContext(CurrentAgentContext);
}
